document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || form.closest('.main-product')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button) button.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Niet toegevoegd');
    const cart = await fetch('/cart.js').then((res) => res.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const toast = document.querySelector('[data-toast]');
    if (toast) { toast.textContent = 'Toegevoegd aan je winkelwagen'; toast.classList.add('is-visible'); setTimeout(() => toast.classList.remove('is-visible'), 2200); }
  } catch (error) { window.location.href = '/cart'; }
  finally { if (button) button.disabled = false; }
});
